// Generated from SVG to Code Figma Plugin

export const BaseLineMarket = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4 6C4 4.34315 5.34315 3 7 3H17C18.6569 3 20 4.34315 20 6V19.2902C20 20.8821 18.2306 21.836 16.9008 20.961L13.0992 18.46C12.4321 18.0211 11.5679 18.0211 10.9008 18.46L7.09923 20.961C5.76936 21.836 4 20.8821 4 19.2902V6Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
